import Typography, { type TypographyProps } from '@mui/material/Typography'

type KbdProps = TypographyProps

export const Kbd = ({ children, ...props }: KbdProps) => {
    return (
        <Typography
            component="kbd"
            variant="caption"
            sx={{
                fontFamily: 'monospace',
                fontWeight: 700,
                borderColor: 'divider',
                borderStyle: 'solid',
                borderWidth: '1px 1px 3px',
                backgroundColor: 'action.hover',
                borderRadius: '0.35rem',
                px: 0.5,
                py: 0,
            }}
            {...props}
        >
            {children}
        </Typography>
    )
}
